import { FC } from 'react'
import CalculationPosition from '../../../../../../types/api/calculation-position'
import StampSearchWrapper from './stamp-search-wrapper'
import VirtualStampModal from './virtual-stamp-modal'
import { NamePath } from 'antd/es/form/interface'

/** Для колонки «Штамп»: при withoutCutting — модалка с полями виртуального штампа (Ш×Д, Ручьи, Вал), иначе — выбор штампа по характеристикам. */
interface StampOrVirtualStampFormItemProps {
    record?: CalculationPosition
    dataIndex?: NamePath
}

const StampOrVirtualStampFormItem: FC<StampOrVirtualStampFormItemProps> = ({
    record,
    dataIndex,
}) => {
    if (record?.withoutCutting) {
        return <VirtualStampModal dataIndex={dataIndex} record={record} />
    }
    return <StampSearchWrapper />
}

export default StampOrVirtualStampFormItem
